{
  "form": {
    "required": "{name} jest wymagane",
    "incomplete": "Przepraszamy, nie wszystkie pola są wypełnione poprawnie.",
    "invalidPhoneNumber": "Nieważny numer telefonu",
    "phonePlaceholder": "Wyszukaj kody połączeń do kraju",
    "oneRequired": "Tylko jedno z pól jest obowiązkowe"
  },
  "orderFlow": {
    "error": {
      "description": "Coś się stało. Twoje zamówienie było niekompletne. Proszę spróbować ponownie."
    },
    "confirmPayment": {
      "description": "Za chwilę zostaniesz przekierowany do bramki płatności.",
      "redirectToGateway": "Przekierowanie do bramki płatności"
    },
    "complete": {
      "description": "Twoje zamówienie zostało pomyślnie zrealizowane.",
      "receiptIsReadyToDownload": "Twój paragon jest gotowy i możesz go pobrać na swoje urządzenie."
    },
    "showPaymentFailure": {
      "description": "Twoja płatność nie została zakończona pomyślnie."
    },
    "waitForPayment": {
      "description": "Czekamy na wynik Twojej płatności."
    },
    "waitForReceipt": {
      "description": "Generujemy paragon. Poczekajcie chwilę."
    },
    "timeout": {
      "description": "Limit czasu został przekroczony. Wyślemy do Ciebie powiadomienie o wyniku."
    }
  },
  "cancel": "Anuluj",
  "no": "Nie",
  "yes": "Tak",
  "order": "Zamówienie",
  "emailAddress": "Adres e-mail",
  "phoneNumber": "Numer telefonu",
  "somethingHappenedTryItAgain": "Coś się stało. Proszę spróbować ponownie.",
  "previousTab": "Poprzedni",
  "nextTab": "Dalej",
  "goBack": "Wróć",
  "download": "Pobierz",
  "noMatches": "Brak dopasowań",
  "firstName": "Imię",
  "lastName": "Nazwisko",
  "companyName": "Company name",
  "regNum": "REGON",
  "regLocation": "Zarejestruj lokalizację",
  "vat": "VAD ID",
  "taxId": "Tax Number",
  "jobPosition": "Funkcja / stanowisko",
  "attentionTo": "Uwaga na",
  "street": "Ulica",
  "houseNum": "Numer domu",
  "city": "Miasto",
  "zip": "ZIP",
  "country": "Kraj",
  "accept": "Akceptuj",
  "refuse": "Odrzucić",
  "localeSettings": {
    "title": "Ustawienia języka",
    "localeSelect": "Używaj języka"
  },
  "baasSimManagementLite": {
    "simAuthenticationFailed": "Uwierzytelnianie SIM nie powiodło się",
    "simLoading": "Ładowanie karty SIM...",
    "noActivePackage": "Bez pakietu",
    "availablePackages": "Dostępne pakiety",
    "simLoadDataFailed": "Nie udało się załadować danych SIM",
    "inactiveAndSynchronizationInProgress": "Karta SIM nie jest aktywna. Synchronizacja stanu może potrwać do 2 godzin.",
    "login": {
      "authorizationCode": "Authorization Code",
      "authorizationCodeValidation": "Authorization code is max 6 length alphanum code."
    },
    "loginType": {
      "go": "Go",
      "identificationCode": "Kod identyfikacyjny",
      "insertSimIdentification": "Włóż identyfikator karty SIM",
      "invalidIdentificationCode": "Nieprawidłowy kod identyfikacyjny"
    },
    "package": {
      "purchaseInProgress": "Zakup na bieżąco",
      "buyFor": "Kupić za",
      "inactiveAndSynchronizationInProgress": "Karta SIM nie jest aktywna. Synchronizacja stanu może potrwać do 2 godzin."
    },
    "packageOrder": {
      "description": "Prosimy o podanie adresu e-mail przed przekierowaniem do bramki płatności, na który wyślemy dowód wpłaty.",
      "requiredTermsAndConditions": "Przed zamówieniem pakietu należy zaakceptować regulamin.",
      "showBillingInfo": "Wypełnij informacje rozliczeniowe",
      "billingName": "Nazwisko"
    },
    "unprocessedPackages": {
      "foundUnprocessed": "Zamówienie jest przetwarzane. Ta operacja może potrwać kilka minut. Prosimy o oczekiwanie.",
      "warnUnprocesse": "Zamówienie jest przetwarzane. Czy na pewno chcesz zamówić kolejny pakiet?"
    },
    "usageBar": {
      "total": "Razem",
      "used": "Zużyte",
      "remaining": "Pozostaje",
      "validTo": "Ważność do"
    }
  },
  "proposal": {
    "acceptForm": {
      "availableOffers": "Dostępne oferty",
      "companyInformations": "Informacje o firmie",
      "address": "Adres",
      "contactPersonInformation": "Dane osoby kontaktowej",
      "proposalAccpetFailed": "Przyjęcie propozycji nie powiodło się",
      "alternative": "Alternatywa",
      "comment": "Dodatkowy komentarz",
      "availableOffersHint": "Wybierz jedną lub więcej ofert do zaakceptowania.",
      "tabs": {
        "offerAndCompany": "Oferta i firma",
        "addresses": "Adresy",
        "bankDetail": "Połączenie z bankiem"
      },
      "personalCustomerPassword": {
        "label": "Osobiste hasło klienta",
        "hint": "Wymagane do weryfikacji tożsamości podczas kontaktu z naszym zespołem pomocy technicznej"
      },
      "invoiceReceipt": {
        "title": "Invoice Receipt",
        "emailAddress": "E-Mail Adress for Invoice Receipt",
        "monthlyEmailNotificationNotIncludePDF": "Miesięczne powiadomienie e-mail nie powinno zawierać kopii e-faktury w formacie PDF"
      },
      "billingAddress": {
        "title": "Billing Information",
        "sameAsCustomerInformation": "takie same jak informacje o kliencie"
      },
      "deliveryAddress": {
        "title": "Delivery address",
        "sameAsCustomerInformation": "takie same jak informacje o kliencie"
      },
      "adminAccessCredentials": {
        "title": "SIM Admin / Access Credentials for the myFUSION Portal",
        "hint": "Administrator SIM otrzymuje pełne prawa dostępu w portalu myFUSION. Administrator SIM może tworzyć dodatkowych użytkowników z różnymi poziomami uprawnień.",
        "firstName": "SIM Admin First Name",
        "lastName": "SIM Admin Last Name",
        "jobPosition": "SIM Admin Function / Position",
        "phoneNumber": "SIM Admin Phone Number",
        "emailAddress": "SIM Admin E-mail"
      },
      "bankDetails": {
        "title": "Bank Details",
        "accountHolder": "Account Holder",
        "bankName": "Bank Name",
        "bic": "BIC",
        "iban": "IBAN",
        "street": "Street (Account Holder)",
        "postalCode": "Postal Code (Account Holder)",
        "city": "City (Account Holder)"
      },
      "companyVerification": {
        "title": "Weryfikacja firmy",
        "hint": "Proszę podać co najmniej jedno z poniższych: Unternehmensregister EUID lub koncesja handlowa.",
        "euid": "Unternehmensregister EUID",
        "euidHelp": "European Unique Identifier (np. DEXXX...)",
        "tradeLicense": "Koncesja handlowa (PDF)",
        "tradeLicenseHelp": "Prześlij swoją koncesję handlową jako plik PDF",
        "validationRequired": "Proszę podać EUID lub koncesję handlową",
        "invalidFileType": "Akceptowane są tylko pliki PDF"
      },
      "countOfSims": "Liczba zamówionych kart SIM nie może być większa niż trzykrotność pierwotnego zamówienia",
      "simsAmount": "Liczba kart SIM",
      "differentSimsAmount": "Zamów inną liczbę kart SIM",
      "acceptProposal": "Zaakceptuj propozycję"
    },
    "refuseDialog": {
      "refuseDialogTitle": "Potwierdzenie odrzucenia oferty"
    },
    "refuseForm": {
      "reasonText": "Prosimy o podanie powodu odrzucenia oferty",
      "refuseDialogText": "Czy na pewno chcesz odrzucić propozycję?",
      "proposalRefuseFailed": "Odrzucenie propozycji nie powiodło się"
    },
    "proposalLoading": "Ładowanie propozycji...",
    "proposalLoadDataFailed": "Ładowanie danych propozycji nie powiodło się",
    "proposalIsAccepted": "Propozycja zostaje przyjęta",
    "proposalIsRefused": "Propozycja zostaje odrzucona",
    "proposalExpired": "Propozycja wygasła",
    "proposalNumber": "Ponuka č.",
    "validTo": "Ważne do"
  },
  "languages": {
    "en": "English",
    "cs": "Čeština",
    "sk": "Slovenský",
    "pl": "Polski",
    "de": "Deutsch"
  }
}
